export function isValidEmail(email: string): Boolean {
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
}

export function isIntegerInRange(input: any, min: number, max: number): Boolean {
  if(min > max) throw new Error('Min > Max');
  if(input >>> 0 !== parseFloat(input)) return false; //Source: https://stackoverflow.com/a/10835227

  const integerValue = parseInt(input);
  return min <= integerValue && max >= integerValue;
}

export function getRandomIndex(array: Array<any>){
  if (array.length < 1)
    throw new Error('Array could not be empty for randomIndex')
  return Math.floor(Math.random() * array.length);
}
